export default __webpack_public_path__ + "static/media/pictogramTrash64.72c78ede.svg";